var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#127CFF",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_38)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5622 29.3143C19.9573 29.3143 27.0186 21.7697 27.0186 17.6516C27.0186 13.5336 23.6802 10.1952 19.5622 10.1952C15.4441 10.1952 12.1057 13.5336 12.1057 17.6516C12.1057 21.7697 19.167 29.3143 19.5622 29.3143ZM19.5622 21.3811C21.65 21.3811 23.3426 19.6885 23.3426 17.6006C23.3426 15.5128 21.65 13.8202 19.5622 13.8202C17.4743 13.8202 15.7817 15.5128 15.7817 17.6006C15.7817 19.6885 17.4743 21.3811 19.5622 21.3811Z",
    fill: "#127CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1057 17.6516C12.1057 21.7697 19.167 29.3143 19.5622 29.3143V21.3811C17.4743 21.381 15.7817 19.6885 15.7817 17.6006C15.7817 15.5128 17.4743 13.8202 19.5622 13.8202V10.1952C15.4441 10.1952 12.1057 13.5336 12.1057 17.6516Z",
    fill: "#299ED2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(12 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin01);
export default __webpack_public_path__ + "static/media/Pin01.21668c90fd76891a9c62b2c42ccbb4b2.svg";
export { ForwardRef as ReactComponent };